module.exports = __webpack_public_path__ + "static/media/video.21d2d0f3.mp4";